import React, { useState } from "react";

import { motion } from "framer-motion";
import { FaChevronDown } from "../../assets/icons";
import { HeaderTabMenu, imageWhileHover } from "../../utils/animations";

const DropMenu = ({ data, stateValue, stateFunc, type }) => {
  const [isMenu, setIsMenu] = useState(false);
  const [value, setValue] = useState(stateValue ? stateValue : null);
  return (
    <div className="border border-gray-300 rounded-md px-4 py-1 w-275 relative cursor-pointer hover:border-gray-400">
      <div
        className="flex items-center justify-evenly gap-2 "
        onClick={() => setIsMenu(!isMenu)}
      >
        {stateValue ? (
          <>
            <div className="w-full flex items-center justify-start gap-3">
              <motion.img
                src={stateValue.thumb}
                className="w-12 h-12 min-w-[40px] object-cover rounded-md shadow-md"
              />
              <p className="text-lg text-textColor">{stateValue?.name}</p>
            </div>
          </>
        ) : (
          <>
            <p className="text-lg text-textColor">Select a trainer</p>
          </>
        )}
        <FaChevronDown
          className={`-rotate-0 ${
            isMenu && "-rotate-180"
          } transition-all ease-in-out duration-300`}
        />
      </div>
      {isMenu &&
        data?.map((n) => (
          <motion.div
            key={n.trainer_id}
            {...HeaderTabMenu}
            className="z-40 w-275 rounded-md py-3 bg-card  shadow-md absolute top-12 left-0 flex flex-col gap-3"
            onClick={() => {
              stateFunc(n);
              setIsMenu(!isMenu);
            }}
          >
            <div className=" w-full px-3 py-1 gap-y-2 flex items-center justify-start hover:bg-gray-200 gap-3">
              <motion.div className="w-12 min-w-[40px] h-12 rounded-md overflow-hidden bg-gray-300">
                <motion.img src={n.thumb} {...imageWhileHover} />
              </motion.div>
              <p className="text-xl text-textColor ">{n.name}</p>
            </div>
          </motion.div>
        ))}
    </div>
  );
};

export default DropMenu;
